<template>
  <div>
    <el-dialog title="发票识别" :visible.sync="visible" :append-to-body="true" @closed="handlerDialogClosed">
      <upload
        name="invoice"
        :config="uploadConfig" ref="uploading_invoice" @on-success="file=>handlerFileUploadSuccess(file)"  @on-loaded="fileList=>handlerFileLoaded(fileList)"
      ></upload>
      <div>
        <p>备注</p>
        <p class="remark-content">
          • 每一张发票识别完之后会自动在下方明细表插入一行数据并关联该发票；
          <br >
          • 可以批量选择多张图；
          <br >
        </p>
      </div>
      <div class="sync-button" style="">
        <el-button size="medium" :loading="syncing" type="primary" @click="submit()" icon="el-icon-data-analysis" >{{btnTitle}}</el-button>

      </div>
    </el-dialog>

  </div>
</template>

<script>
import {mixin} from './index.js';
export default {
  name: 'ocr-invoice',
  mixins: [mixin]
};
</script>

<style scoped>

  .remark-content{
    color: #808080;
    font-size: 12px;
    line-height: 2;
  }
  .sync-button{
    margin-top: 10px;
    text-align: center;
    /*position: absolute;*/
    /*width: 550px;*/
    /*bottom: 20px;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/ocr-invoice/index.vue